module.exports = __webpack_public_path__ + "static/media/Level-4.fa58de20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Level-4.svg
// module id = 1309
// module chunks = 0